// layout
import { RDashboardLayout } from "@/components/reusable_components/layouts"

// routes
import routes from "./routes"

// default dashboard routes
export default [
    {
        path        : "/", 
        component   : RDashboardLayout, 
        children    : routes,
    },
]